<div class="multiStepDropdownContainer" [style.width]="dropdownWidth">
  <pp-multi-step-dropdown
    [ppSteps]="steps"
    [ppBackCallback]="backCallback"
    [ppIsLoading]="isLoading"
    [ppSelectedId]="selectedId"
    [ppSelectedParentId]="selectedParentId"
  />
</div>
